var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlackLink = function SvgBlackLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4153 24.678C12.7845 29.637 27.6302 25.6738 27.9927 13.6103C28.3551 1.54685 15.1872 -0.89258 8.64351 0.651278C-5.8197 4.07316 0.797798 18.5493 7.4153 24.678Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0067 16.129C16.7138 16.4219 16.7138 16.8968 17.0067 17.1897C17.2996 17.4826 17.7744 17.4826 18.0673 17.1897L21.424 13.833C21.4715 13.7855 21.5112 13.7333 21.5433 13.6778C21.6072 13.5674 21.6438 13.4392 21.6438 13.3025C21.6438 13.0887 21.5543 12.8957 21.4107 12.7591L18.0673 9.41571C17.7744 9.12282 17.2996 9.12282 17.0067 9.41571C16.7138 9.70861 16.7138 10.1835 17.0067 10.4764L19.0828 12.5525L8.6582 12.5526C8.24398 12.5527 7.9082 12.8884 7.9082 13.3027C7.90821 13.7169 8.244 14.0527 8.65821 14.0526L19.0831 14.0525L17.0067 16.129Z",
    fill: "white"
  })));
};
export default SvgBlackLink;